module.exports = __webpack_public_path__ + "media/src/images/mails/iversity-logo-fb76409ebe2b696b3900d0a205f45afc.png";